import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { LoginDialogComponent } from '../../components/login-dialog/login-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginComponent implements OnInit {

  public showRegister = false;
  public userCreated = false;
  @ViewChild(LoginDialogComponent) loginDialog: LoginDialogComponent;

  constructor(
    public translate: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data?.forceMobileLayout) {
      document.body.classList.add('force-mobile-login');
    }
  }

  toggleForm() {
    this.showRegister = !this.showRegister;
  }

  userCreatedEvent(data) {
    this.userCreated = data;
    if (data === 'openLogin') {
      this.showRegister = false;
      this.userCreated = false;
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('force-mobile-login');
  }

}